module.exports = __webpack_public_path__ + "static/media/radio-unchecked.e7d5f14a.svg";